import React, { useLayoutEffect } from 'react';
import { useNavigation } from 'expo-router';
import { Platform } from 'react-native';

import { useResponsive } from '@sg/garnish';

import { LoadingAnimation } from '../../components';
import { AccountSignedOutMessage } from '../../components/Account';
import { useIsLoggedIn, useIsLoggingIn } from '../../context/AuthMachine';
import { ProfileScreen } from '../ProfileScreen';
import { AccountScreenContent } from './AccountScreen.content';
import { AccountScreenHeader } from './components';

// ─────────────────────────────────────────────────────────────────────────────

export const AccountScreen = () => {
  const { currentBreakpoint } = useResponsive();

  const navigation = useNavigation();
  const isLoggedIn = useIsLoggedIn();
  const isLoggingIn = useIsLoggingIn();
  const setOptions = navigation.setOptions;

  // ─── Flags ────────────────────────────────────────────────────────────────

  // ─── Derived ──────────────────────────────────────────────────────────────

  const shouldRenderScreenHeader = currentBreakpoint.isXS;

  // ─── Effects ─────────────────────────────────────────────────────────

  useLayoutEffect(() => {
    setOptions({ headerShown: false });
  }, [setOptions]);

  // ─────────────────────────────────────────────────────────────────────

  if (isLoggingIn) {
    return <LoadingAnimation />;
  }

  if (!isLoggedIn && Platform.OS === 'web') {
    return (
      <>
        {shouldRenderScreenHeader ? <AccountScreenHeader /> : null}
        <AccountSignedOutMessage />
      </>
    );
  }

  if (!currentBreakpoint.isXS && isLoggedIn) {
    return <ProfileScreen />;
  }

  return <AccountScreenContent />;
};
